import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useFormik } from 'formik';
import UnitAccordion from '../components/unitAccordion';
import useAPI from '../../../hooks/useAPI';
import SmallLoader from '../../widgets/SmallLoader'
import { states } from '../../../services/base'
import { useNavigate } from 'react-router';
import { tenantInitialValues, roomInitialValues } from '../../../services/utils';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { BURL } from '../../../services/base';
import axios from 'axios';
import { string } from 'yup';
import * as Yup from 'yup';
import { Alert, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Snackbar } from '@mui/material';
import { type } from '@testing-library/user-event/dist/type';

const steps = ['Find User', 'Tenant Details', 'Add Invoice'];

export default function TenantHorizontalLinearStepper({ getProperties, refetchTenants, open, setOpen, currentPropertyId, currentUnitId, currentRoomId }) {

    // Formik form
    const { values, handleChange, resetForm } = useFormik({ initialValues: tenantInitialValues })
    // End of formik

    const navigate = useNavigate();
    const [activeStep, setActiveStep] = React.useState(0);
    const [skipped, setSkipped] = React.useState(new Set());
    const [properties, setProperties] = React.useState([]);
    const [rooms, setRooms] = React.useState([]);
    const [startDate, setStartDate] = React.useState('');
    const [endDate, setEndDate] = React.useState('');
    const [daysBetween, setDaysBetween] = React.useState(0);

    const isStepOptional = (step) => {
        return step === 1;
    };

    const isStepSkipped = (step) => {
        return skipped.has(step);
    };

    const nextStep = () => {
        let newSkipped = skipped;
        if (isStepSkipped(activeStep)) {
            newSkipped = new Set(newSkipped.values());
            newSkipped.delete(activeStep);
        }

        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped(newSkipped);
    }

    const handleNext = async () => {
        setErrorText(null);

        if (activeStep + 1 === 1) {
            await handleSearch();
        } else if (activeStep + 1 === 2) {
            await addTenants();
        } else if (activeStep + 1 === 3) {
            await handleInvoiceItemSave();
        } else {
            nextStep();
        }
    };


    const { POST, GET } = useAPI()
    const [loading, setLoading] = React.useState(false);
    const [done, setDone] = React.useState(false);
    const [errorText, setErrorText] = React.useState(null);
    const [property, setProperty] = React.useState(null);
    const [units, setUnits] = React.useState([]);
    const [invoices, setInvoices] = React.useState([]);
    const [showInvoiceDetails, setShowInvoiceDetails] = React.useState(false);
    const [invoiceItems, setInvoiceItems] = React.useState([]);
    const [invoiceDetails, setInvoiceDetails] = React.useState([]);
    const [propertyId, setPropertyId] = React.useState('' || null);
    const [unitId, setUnitId] = React.useState('' || null);
    const [tenantRoomId, setTenantRoomId] = React.useState('' || null);
    const [email, setEmail] = React.useState('');
    const [isTenantDetails, setIsTenantDetails] = React.useState(false);
    const [userId, setUserId] = React.useState('');
    const [invoiceId, setInvoiceId] = React.useState('');
    const [confirmLoading, setConfirmLoading] = React.useState(false);
    const [tenantPayload, setTenantPayload] = React.useState({
        userId: 0,
        propertyId: 0,
        roomId: 0,
        checkIn: '',
        stayDuration: '',
        invoiceId: 0 || null
    });
    const [userDetails, setUserDetails] = React.useState({
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        phone: '',
        propertyId: 0,
        roomId: 0,
        checkIn: '',
        stayDuration: '',
        invoiceId: 0 || null
    });
    const [editableIndex, setEditableIndex] = React.useState(null);
    const [showToaster, setShowToaster] = React.useState(false);
    const [toasterType, setToasterType] = React.useState('success');
    const [message, setMessage] = React.useState(null);
    const [searchValue, setSearchValue] = React.useState('');
    const [tenantInvoiceDetails, setTenantInvoiceDetails] = React.useState([]);
    const [confirmationOpen, setConfirmationOpen] = React.useState(false);
    const [removedInvoiceDetailIds, setRemovedInvoiceDetailIds] = React.useState([]);
    const { DELETEREQ } = useAPI();

    const token = localStorage.getItem('token');

    // Check if value is email
    const isEmail = (value) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^/s@]+$/;
        return emailRegex.test(value);
    }

    // Check if value is phone
    const isPhone = (value) => {
        const localphoneRegex = /^0\d{10}$/;
        const intlPhoneRegex = /^\+?[0-9]{7, 15}$/;
        return localphoneRegex.test(value) || intlPhoneRegex.test(value);
    }
    // Normalize phone number to Nigeria format
    const normalizePhone = (value) => {
        let phone = value.replace(/\s+/g, "");
        if (phone.startsWith("+")) {
            return phone;
        }

        if (phone.startsWith("0") && phone.length === 11) {
            return "+234" + phone.slice(1);
        }
        return phone;
    }

    const handleSearch = async () => {
        let payload = {};

        if (isEmail(searchValue)) {
            payload.email = searchValue;
        } else if (isPhone(searchValue)) {
            payload.phone = normalizePhone(searchValue);
        } else {
            setShowToaster(true);
            setToasterType('error');
            setMessage("Please enter a valid email or phone number");
            return;
        }

        try {
            const response = await axios.get(`${BURL}app/user`, {
                params: payload,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response?.status) {
                tenantPayload.userId = response.data.data.userId;
                response.data.data ? setIsTenantDetails(true) : setIsTenantDetails(false);
                setUserId(response.data.data.userId);
                setUserDetails({
                    firstname: response.data.data.firstname,
                    lastname: response.data.data.lastname,
                    email: response.data.data.email,
                    phone: response.data.data.phone,
                    roomId: currentRoomId
                });
                if (response.status) nextStep();
                setIsTenantDetails(true);
            } else {
                const errorMessage = typeof response.message === 'string'
                    ? response.message
                    : JSON.stringify(response.message);
                setErrorText(errorMessage);
                setIsTenantDetails(false);
            }
        } catch (err) {
            if (err?.response.data.message == 'Account does not exist') {
                setUserDetails({
                    firstname: '',
                    lastname: '',
                    email: payload.email ? payload.email : '',
                    phone: payload.phone ? payload.phone : '',
                    roomId: currentRoomId
                });
                nextStep();
            } else {
                setErrorText(err?.response.data.message || 'An unexpected error occurred.');
                setIsTenantDetails(false);
            }
        } finally {
            setLoading(false);
        }
    }

    const formik = useFormik({
        initialValues: {
            title: '',
            description: '',
            amount: ''
        },
        validationSchema: Yup.object({
            title: Yup.string().required('Title is required'),
            description: Yup.string().required('Description is required'),
            amount: Yup.number().typeError('Amount must be a number').required('Amount is required')
        }),
    });

    // const handleInputChange = (e) => {
    //     const { name, value } = e.target;
    //     setUserDetails({
    //         ...userDetails,
    //         [name]: value
    //     });
    // };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setUserDetails((prev) => ({
            ...prev,
            [name]: value,
        }));

        // ✅ keep invoiceId state in sync (handleInvoiceItemSave uses invoiceId)
        if (name === 'invoiceId') {
            setInvoiceId(value);
        }
    };


    const getAllProperties = React.useCallback(async () => {
        setLoading(true);
        setErrorText(null);
        const response = await GET(`admin/properties`);
        setLoading(false);

        if (response?.status) {
            setProperties(response.data);
        } else {
            setErrorText(response.message ?? 'Request Error');
        }
    }, []);

    const handlePropertyChange = async (e) => {
        setPropertyId(e.target.value);
        getUnitByPropertyId(e.target.value);
    }

    const handleUnitChange = async (e) => {
        setUnitId(e.target.value);
        getRoomByUnit(e.target.value);
    }

    const calculateDays = () => {
        const start = new Date(startDate);
        const end = new Date(endDate);

        // Calculate the difference in milliseconds
        const diffInMs = end - start;

        // Convert milliseconds to days
        const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
        return diffInDays;
    };

    React.useEffect(() => {
        getAllProperties();
    }, []);

    React.useEffect(() => {
        getAllProperties();
    }, []);

    const handleToasterClose = () => {
        setShowToaster(false);
    };

    const handleAddItem = () => {
        setInvoiceItems(e => [...e, formik.values]);
        formik.resetForm();
    }

    const handleClose = () => {
        setConfirmationOpen(false);
    };

    const handleDeleteItem = (index) => {
        const itemToRemove = invoiceItems[index];

        const newItems = [...invoiceItems];
        newItems.splice(index, 1);
        setInvoiceItems(newItems);
        if (itemToRemove?.id && !removedInvoiceDetailIds.includes(itemToRemove.id)) {
            setRemovedInvoiceDetailIds(prev => [...prev, itemToRemove.id]);
        }
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleReset = async () => {
        setActiveStep(0);
        setSkipped(new Set());
        setOpen(false);
        setDone(false);

        try {
            await(refetchTenants?.() ?? Promise.resolve());
        } catch (e) {
            openToaster('error', 'Could not refresh tenants list');
            console.error(e);
        }
    };

    // Property
    const propertyList = properties.map(property => {
        return (
            <MenuItem className='capitalize' value={property.propertyId}>{property.property.name}</MenuItem>
        )
    });
    // End of property  

    // Unit
    const unitList = units.map(unit => {
        return (
            <MenuItem value={unit.id}>{unit.name}</MenuItem>
        )
    })
    // End of unit  

    // Room
    const roomList = rooms.map(room => {
        return (
            <MenuItem className='capitalize' value={room.id}>{room.tag}</MenuItem>
        )
    })
    // End of room  

    // invoiceList
    const invoiceList = invoices.map(invoice => {
        return (
            <MenuItem value={invoice.id}>{invoice.title}</MenuItem>
        )
    })
    // End of invoiceList

    // handling multiple units

    React.useEffect(() => {
        if (activeStep === 1 && !units.length) addUnit();
        // eslint-disable-next-line
    }, [activeStep, units.length])

    const addUnit = () => {
        setUnits(e => [...e, {
            id: e.length + 1,
            name: 'New Unit ' + (e.length + 1),
            noOfRooms: 1, saved: false,
            rooms: [{ tag: 'Room 1' }],
        }])
    }

    // when the dialog close
    React.useEffect(() => {
        if (!open && done) {
            setOpen(false);
            setDone(false);
            setActiveStep(0);
        }
        // refetch properties if the method is been passed down to this component
        const properties = getProperties && getProperties();

        // eslint-disable-next-line
    }, [open, done])


    // check if setup is completed
    React.useEffect(() => {
        // get unsaved units
        const unsavedUnits = units.filter(each => !each.saved)
        // unit setup step is skipped or (we have units, no unsaved unit and property has been set)
        if ((!unsavedUnits.length && property && units.length) || isStepSkipped(1)) {
            resetForm();
            setDone(true);
            setUnits([]);
            setActiveStep(2);
            setProperty(null);
            setSkipped(new Set())
        }
        // eslint-disable-next-line
    }, [units, property, activeStep]);

    const getUnitByPropertyId = React.useCallback(async (propertyId) => {
        if (propertyId) {
            const token = localStorage.getItem('token');
            setLoading(true);
            setErrorText(null);
            const response = await axios.get(`${BURL}/admin/properties/${propertyId}/units`, {
                params: {
                    withRooms: false,
                    withProperty: false
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            // const response = await GET(`admin/properties`)
            setLoading(false);
            if (response?.status) {
                const res = response.data.data
                setUnits(res);
            } else {
                // setErrorText(response.message ?? 'Request Error');
            }
        }
    });

    const getRoomByUnit = React.useCallback(async (id) => {
        if (id) {
            setLoading(true);
            setErrorText(null);
            const response = await axios.get(`${BURL}/admin/properties/units/${id}/rooms`, {
                params: {
                    withProperty: false,
                    withUnit: true,
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setLoading(false);

            if (response?.status) {
                const res = response.data.data
                setRooms(res);
            } else {
                setErrorText(response.message ?? 'Request Error');
            }
        }
    });

    const getInvoiceByPropertyId = React.useCallback(async () => {
        const token = localStorage.getItem('token');
        setLoading(true);
        setErrorText(null);

        try {
            const response = await axios.get(`${BURL}admin/invoices/property`, {
                params: {
                    propertyId
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.status === 200) {
                const res = response.data.data;
                setInvoices(res);
            } else {
                setErrorText(response.data?.message ?? 'Request Error');
            }
        } catch (err) {
            setErrorText(err.response?.data?.message || err.message || 'Unknown error');
        } finally {
            setLoading(false);
        }
    }, [propertyId]);

    const getInvoiceById = async (invoice_id) => {
        const token = localStorage.getItem('token');
        setLoading(true);
        setErrorText(null);
        try {
            const response = await axios.get(`${BURL}admin/invoices/property/${invoice_id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.status === 200) {
                const res = response.data.data;
                setInvoiceItems(res.details);
            } else {
                setErrorText(response.data?.message ?? 'Request Error');
            }
        } catch (err) {
            setErrorText(err.response?.data?.message || err.message || 'Unknown error');
        } finally {
            setLoading(false);
        }
    };

    React.useEffect(() => {
        getInvoiceByPropertyId();
        if (propertyId) {
            getUnitByPropertyId();
        }
        if (unitId) {
            getRoomByUnit();
        }
    }, []);

    const addTenants = async () => {
        setLoading(true);
        setErrorText(null);

        try {
            let contactPayload = {};

            if (isEmail(searchValue)) {
                contactPayload.email = searchValue.trim();
            } else if (isPhone(searchValue)) {
                contactPayload.phone = normalizePhone(searchValue);
            } else {
                openToaster('error', 'Please enter a valid email or phone number');
                return;
            }

            const calcDay = calculateDays();

            const body = isTenantDetails
                ? {
                    ...tenantPayload,
                    checkIn: startDate,
                    propertyId,
                    roomId: userDetails?.roomId,
                    invoiceId: userDetails?.invoiceId,
                    stayDuration: calcDay,
                    ...contactPayload,
                }
                : {
                    ...userDetails,
                    checkIn: startDate,
                    propertyId,
                    stayDuration: calcDay,
                    ...(contactPayload.phone ? { phone: contactPayload.phone } : {}),
                    ...(contactPayload.email ? { email: contactPayload.email } : {}),
                };

            if (!isTenantDetails) tenantPayload.roomId = userDetails.roomId;
            if (!isTenantDetails && userDetails?.roomId != null) {
                body.roomId = body.roomId ?? userDetails.roomId;
            }

            const response = await POST('admin/tenant-room', body);

            if (!response?.status) {
                const apiMsg =
                    response?.message ||
                    response?.error?.details?.[0]?.message ||
                    response?.error?.message ||
                    'Unable to add tenant. Please try again.';

                openToaster('error', apiMsg);
                return;
            }

            const tenantRoomId = response?.tenantRoom?.id;
            if (tenantRoomId) {
                setTenantRoomId(tenantRoomId);
                fetchInvoiceDetailsByTenantRoomId(tenantRoomId);
            }

            openToaster('success', response?.message || 'Tenant added successfully');
            nextStep();

            setUserDetails({
                firstname: '',
                lastname: '',
                email: '',
                phone: '',
                phone: '',
                propertyId: 0,
                roomId: 0,
                checkIn: '',
                stayDuration: '',
                invoiceId: 0 || null
            });
        } catch (err) {
            const msg =
                err?.response?.data?.message ||
                err?.message ||
                'Something went wrong. Please try again.';
            openToaster('error', msg);
        } finally {
            setLoading(false);
        }
    };


    const fetchInvoiceDetailsByTenantRoomId = async (tenantRoomId) => {
        const token = localStorage.getItem('token');
        if (tenantRoomId !== undefined) {
            try {
                const response = await axios.get(`${BURL}admin/invoices/tenantRoom/`, {
                    params: {
                        tenantRoomId: tenantRoomId
                    },
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                });
                const tenant_invoice_details = await response.data.data;
                setInvoiceId(tenant_invoice_details[0].details[0].invoiceId);
                setTenantInvoiceDetails(tenant_invoice_details[0].details);
                setInvoiceItems(tenant_invoice_details[0].details);
            } catch (err) {
                setErrorText(err);
            } finally {
                setLoading(false);
            }
        } else {
            return '';
        }
    }

    const fetchTenantRoomByTenantRoomId = async (tenantRoomId) => {
        const token = localStorage.getItem('token');
        if (tenantRoomId !== undefined) {
            try {
                const response = await axios.get(`${BURL}admin/tenant-rooms/${tenantRoomId}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                });
                const tenant_room_details = await response.data.data;

                const updatedRoomDetails = {
                    ...tenant_room_details,
                    totalAmount: tenant_room_details?.invoices[0]?.totalAmount == null ? 0 : tenant_room_details?.invoices[0]?.totalAmount,
                    totalPaid: tenant_room_details?.invoices[0]?.totalPaid == null ? 0 : tenant_room_details?.invoices[0]?.totalPaid,
                    balance: tenant_room_details?.balance == null ? 0 : tenant_room_details?.balance,
                }
            } catch (err) {
                setErrorText(err);
            } finally {
                setLoading(false);
            }
        } else {
            return '';
        }
    };

    const handleInvoiceChange = (e) => {
        setInvoiceId(e.target.value);
        setShowInvoiceDetails(true);
        getInvoiceById(e.target.value);
    }

    const openToaster = React.useCallback((type, msg) => {
        setToasterType(type);
        setMessage(msg);
        setShowToaster(true);
    }, []);

    const handleItemChange = (e, index) => {
        const { name, value } = e.target;
        const updatedItems = [...invoiceItems];
        updatedItems[index] = { ...updatedItems[index], [name]: value };
        setInvoiceItems(updatedItems);
    };

    const handleSave = (index) => {
        setEditableIndex(null);
    }

    const handleDeleteInvoiceItemFromDB = async () => {
        const url = 'admin/invoice-items';
        const token = localStorage.getItem('token');
        const body = { invoiceDetailIds: removedInvoiceDetailIds, type: 'tenantRoom' };

        const response = await DELETEREQ(url, body, token);

        if (!response?.status) {
            const msg =
                response?.message ||
                response?.error?.details?.[0]?.message ||
                'Failed to delete invoice items';
            openToaster('error', msg);
            throw new Error(msg);
        }

        openToaster(
            'success',
            response?.message || response?.data?.message || 'Deleted invoice item(s) successfully'
        );

        return response;
    };

    const handleInvoiceItemSave = async () => {
        console.log('Hi, I got here');

        setConfirmLoading(true);

        try {
            const effectiveInvoiceId =
                invoiceId ||
                userDetails?.invoiceId ||
                invoiceItems?.[0]?.invoiceId ||
                tenantInvoiceDetails?.[0]?.invoiceId;

            if (!effectiveInvoiceId) {
                openToaster('error', 'Invoice is not selected / missing invoiceId.');
                return;
            }

            if (removedInvoiceDetailIds.length > 0) {
                await handleDeleteInvoiceItemFromDB();
                setRemovedInvoiceDetailIds([]);
            }

            const newItems = (invoiceItems || []).filter((item) => !item.id);
            if (newItems.length > 0) {
                const url = 'admin/invoice-items';
                const token = localStorage.getItem('token');

                const body = {
                    invoiceId: effectiveInvoiceId,
                    details: newItems,
                };

                const response = await POST(url, body, token);

                if (!response?.status) {
                    const msg =
                        response?.message ||
                        response?.error?.details?.[0]?.message ||
                        'An error occurred while adding invoice items, try again please.';
                    openToaster('error', msg);
                    return;
                }
                setActiveStep(steps.length);
                openToaster(
                    'success',
                    response?.message || response?.data?.message || 'Invoice updated successfully'
                );
                setActiveStep(steps.length);
            } else {
                openToaster('success', 'Invoice updated successfully');
            }

            setInvoiceItems([]);
            setActiveStep(steps.length);
        } catch (err) {
            const msg =
                err?.response?.data?.message ||
                err?.message ||
                'Something went wrong. Please try again.';
            openToaster('error', msg);
        } finally {
            setConfirmLoading(false);
        }
    };


    const loader = <SmallLoader />
    return (
        <Box sx={{ width: '100%' }}>
            <Stepper activeStep={activeStep}>
                {steps.map((label, index) => {
                    const stepProps = {};
                    const labelProps = {};
                    if (isStepSkipped(index)) {
                        stepProps.completed = false;
                    }
                    return (
                        <Step key={label} {...stepProps}>
                            <StepLabel {...labelProps}>{label}</StepLabel>
                        </Step>
                    );
                })}
            </Stepper>
            {activeStep === steps.length ? (
                <React.Fragment>
                    <Typography sx={{ mt: 2, mb: 1 }}>
                        <div className="max-w-md p-5 text-center">
                            Tenant setup has been completed. Click proceed to view tenants or click out to close this dialog.
                        </div>
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                        <Box sx={{ flex: '1 1 auto' }} />
                        <Button onClick={handleReset}>Proceed</Button>
                    </Box>
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <div sx={{ mt: 2, mb: 1 }}>
                        {
                            activeStep === 0 &&
                            <div>
                                <div className="my-10">
                                    <h1 className='text-3xl font-bold text-black'>Find User</h1>
                                    <p className="text-[0.8em] mt-2">Enter the tenant email address or phone number, to fetch the tenant details.</p>
                                    {errorText && <div className='text-sm text-red-500 py-2'>{errorText}</div>}
                                </div>
                                <Box
                                    component="form"
                                    sx={{
                                        '& > :not(style)': { width: '100%' },
                                    }}
                                    noValidate
                                    autoComplete="off"
                                >
                                    <div className='w-full'>
                                        <TextField fullWidth name="email" label="Email/Phone Number" type='text' value={searchValue} onChange={(e) => setSearchValue(e.target.value.trim())} variant="outlined" />
                                    </div>
                                </Box>
                            </div>
                        }
                        {
                            activeStep === 1 &&
                            <div>
                                <div className="my-10">
                                    <h1 className='text-3xl font-bold text-black'> Tenant Details</h1>
                                    {isTenantDetails ? <p className="text-[14px] mt-2">Below is the details of the user. <br /> NOTE: This is displayed because the searched email address is registered. </p> :
                                        <p className="text-[0.8em] mt-2">User does not exist. <br /> Fill in the neccessary information to create tenant </p>}
                                    {errorText && <div className='text-sm text-red-500 py-2'>{errorText}</div>}
                                </div>
                                <Box
                                    component="form"
                                    sx={{
                                        '& > :not(style)': { width: '100%' },
                                    }}
                                    noValidate
                                    autoComplete="off"
                                >
                                    <div className="w-100 gap-4 grid">
                                        <div className="w-100 gap-3 grid grid-cols-[58%,40%]">
                                            <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                                <label htmlFor="" className=''>First Name</label>
                                                <input type="text" disabled={isTenantDetails} className='text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#0000008f] capitalize' name='firstname' value={userDetails.firstname} onChange={handleInputChange} placeholder="John" />
                                            </div>
                                            <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                                <label htmlFor="" className=''>Last Name</label>
                                                <input type="text" disabled={isTenantDetails} className='text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#000000ba] capitalize' name='lastname' value={userDetails.lastname} onChange={handleInputChange} placeholder="Doe" />
                                            </div>
                                        </div>
                                        <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                            <label htmlFor="" className=''>Email</label>
                                            <input type="email" disabled={isTenantDetails} className='text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#000000ba]' name='email' value={userDetails.email} onChange={handleInputChange} placeholder="johndoe@gmail.com" />
                                        </div>
                                        <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                            <label htmlFor="" className=''>Phone</label>
                                            <input type="text" disabled={isTenantDetails} className='text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#000000ba]' name='phone' value={userDetails.phone} onChange={handleInputChange} placeholder="Phone Number" />
                                        </div>
                                        <div className="w-100 gap-3 grid grid-cols-[58%,40%] mt-2">
                                            <Box sx={{ minWidth: 120 }}>
                                                <FormControl fullWidth >
                                                    <InputLabel id="demo-simple-select-label">Property</InputLabel>
                                                    <Select
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        name='propertyId'
                                                        value={propertyId}
                                                        onChange={handlePropertyChange}
                                                        className='capitalize'
                                                        MenuProps={{
                                                            style: {
                                                                maxHeight: 300,
                                                            },
                                                        }}
                                                    >
                                                        {propertyList}
                                                    </Select>
                                                </FormControl>
                                            </Box>
                                            <Box sx={{ minWidth: 120 }}>
                                                <FormControl fullWidth >
                                                    <InputLabel id="demo-simple-select-label">Unit</InputLabel>
                                                    <Select
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        name='unitId'
                                                        value={unitId}
                                                        className='capitalize'
                                                        onChange={handleUnitChange}
                                                        MenuProps={{
                                                            style: {
                                                                maxHeight: 300,
                                                            },
                                                        }}
                                                    >
                                                        {unitList}
                                                    </Select>
                                                </FormControl>
                                            </Box>
                                        </div>
                                        <Box sx={{ minWidth: 120 }}>
                                            <FormControl fullWidth >
                                                <InputLabel id="demo-simple-select-label">Room</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    name='roomId'
                                                    value={userDetails.roomId}
                                                    className='capitalize'
                                                    onChange={handleInputChange}
                                                    MenuProps={{
                                                        style: {
                                                            maxHeight: 300,
                                                        },
                                                    }}
                                                >
                                                    {roomList}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                        <div className="w-100 gap-4 grid">
                                            <Box sx={{ minWidth: 120 }}>
                                                <FormControl fullWidth >
                                                    <InputLabel id="demo-simple-select-label">Invoice</InputLabel>
                                                    <Select
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        name='invoiceId'
                                                        value={userDetails.invoiceId || ''}
                                                        // onChange={handleInvoiceChange}
                                                        onChange={handleInputChange}
                                                        MenuProps={{
                                                            style: {
                                                                maxHeight: 300,
                                                            },
                                                        }}
                                                    >
                                                        {invoiceList}
                                                    </Select>
                                                </FormControl>
                                            </Box>
                                        </div>
                                        <div className="w-100 gap-3 grid grid-cols-[47%,47%]">
                                            <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                                <label htmlFor="" className=''>Start Date</label>
                                                <input type="date" className='border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:font-[500]' name="startDate" value={startDate}
                                                    onChange={(e) => setStartDate(e.target.value)} />
                                            </div>
                                            <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                                <label htmlFor="" className=''>End Date</label>
                                                <input type="date" className='border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:font-[500]' name="endDate" value={endDate}
                                                    onChange={(e) => setEndDate(e.target.value)} />
                                            </div>
                                        </div>
                                    </div>
                                </Box>
                            </div>
                        }
                        {
                            activeStep === 2 &&
                            <div>
                                <div className="my-10">
                                    <h1 className='text-3xl font-bold text-black'> Invoice Details</h1>
                                    {/* {isTenantDetails ?  */}
                                    <p className="text-[14px] mt-2">Edit/remove any item from the attached invoice list associated with the property. </p>
                                    {/* <p className="text-[0.8em] mt-2">User does not exist. <br /> Fill in the neccessary information to create tenant </p> */}
                                    {/* } */}
                                    {/* {errorText && <div className='text-sm text-red-500 py-2'>{errorText}</div>} */}
                                </div>
                                <Box
                                    component="form"
                                    sx={{
                                        '& > :not(style)': { width: '100%' },
                                    }}
                                    noValidate
                                    autoComplete="off"
                                >
                                    {/* <div className="w-100 gap-4 grid">
                                        <Box sx={{ minWidth: 120 }}>
                                            <FormControl fullWidth >
                                                <InputLabel id="demo-simple-select-label">Invoice</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    name='invoiceId'
                                                    // value={userDetails.invoiceId}
                                                    onChange={handleInvoiceChange}
                                                    MenuProps={{
                                                        style: {
                                                            maxHeight: 300,
                                                        },
                                                    }}
                                                >
                                                    {invoiceList}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    </div> */}
                                    <>
                                        <form>
                                            <div className="pt-5 items-center w-100 flex flex-col md:flex-row gap-3">
                                                <TextField fullWidth id="standard-basic" label="Title" type='text' variant="outlined" name='title' value={formik.values.title} onChange={formik.handleChange} onBlur={formik.handleBlur} error={formik.touched.title && Boolean(formik.errors.title)} helperText={formik.touched.title && formik.errors.title} />
                                                <TextField fullWidth id="standard-basic" label="Description" type='text' variant="outlined" name='description' value={formik.values.description} onChange={formik.handleChange} onBlur={formik.handleBlur} error={formik.touched.description && Boolean(formik.errors.description)} helperText={formik.touched.description && formik.errors.description} />
                                                <TextField fullWidth id="standard-basic" label="Amount" type='text' variant="outlined" name="amount" value={formik.values.amount} onChange={formik.handleChange} onBlur={formik.handleBlur} error={formik.touched.amount && Boolean(formik.errors.amount)} helperText={formik.touched.amount && formik.errors.amount} />
                                            </div>
                                            <div className="flex justify-end mt-3">
                                                <div className='px-4 py-2 border hover:bg-austel-green bg-green-700 text-white flex items-center gap-2 cursor-pointer' onClick={handleAddItem}><p className='font-light text-[16px]'>Add Item</p>
                                                </div>
                                            </div>
                                        </form>
                                        <div className='overflow-x-auto'>
                                            {
                                                Array.isArray(invoiceItems) && invoiceItems.length > 0 ? (
                                                    <>
                                                        {
                                                            invoiceItems.map((item, i) => {
                                                                return (
                                                                    <div className="pt-5 items-center w-full flex flex-col md:flex-row gap-3">
                                                                        <TextField disabled={editableIndex !== i} fullWidth id="standard-basic" label="Title" type='text' className='w-full disabled:bg-gray-400' sx={{ width: '100%' }} variant="outlined" name='title' value={item.title} onChange={(e) => handleItemChange(e, i)} />
                                                                        <TextField disabled={editableIndex !== i} fullWidth id="standard-basic" label="Description" type='text' className='w-full disabled:bg-gray-400' sx={{ width: '100%' }} variant="outlined" name='description' value={item.description} onChange={(e) => handleItemChange(e, i)} />
                                                                        <TextField disabled={editableIndex !== i} fullWidth id="standard-basic" label="Amount" type='text' className='w-full disabled:bg-gray-400' sx={{ width: '100%' }} variant="outlined" name="amount" value={item.amount} onChange={(e) => handleItemChange(e, i)} />
                                                                        {/* Conditional buttons */}
                                                                        {editableIndex === i ? (
                                                                            <Button
                                                                                variant="contained"
                                                                                color="primary"
                                                                                onClick={() => handleSave(i)}
                                                                            >
                                                                                Save
                                                                            </Button>
                                                                        ) : (
                                                                            <>
                                                                                {/* <EditIcon
                                                                                    className="cursor-pointer"
                                                                                    title="Edit"
                                                                                    onClick={() => setEditableIndex(i)}
                                                                                /> */}
                                                                                <DeleteIcon
                                                                                    className="cursor-pointer text-[#6C6C6C]"
                                                                                    sx={{ fontSize: '18px' }}
                                                                                    onClick={() => handleDeleteItem(i)}
                                                                                />
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </>
                                                ) : <div className="pb-5 flex items-center justify-center border-dashed border-green-500 border text-green-500 mt-10 flex-col hover:cursor-pointer bg-white text-[18px]">
                                                    <span className='mt-4'>No item added</span>
                                                </div>
                                            }
                                        </div>
                                    </>
                                </Box>
                            </div>
                        }
                    </div>
                    <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                        <Button
                            color="inherit"
                            disabled={activeStep === 0}
                            onClick={handleBack}
                            sx={{ mr: 1 }}>
                            Back
                        </Button>
                        <Box sx={{ flex: '1 1 auto' }} />
                        {/* {isStepOptional(activeStep) && (
                            <Button color="inherit" onClick={handleSkip} sx={{ mr: 1 }}>
                                Skip
                            </Button>
                        )} */}

                        <Button onClick={handleNext} disabled={loading} className='flex gap-1 items-center'>
                            {activeStep === steps.length - 1 ? 'Finish' : 'Next'}

                            {loading && loader}
                            {confirmLoading && loader}
                        </Button>
                    </Box>
                    {/* Snackbar */}
                    <Snackbar open={showToaster} autoHideDuration={6000} onClose={handleToasterClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                        <Alert
                            onClose={handleToasterClose}
                            severity={toasterType}
                            variant="filled"
                            sx={{ width: '100%' }}
                        >
                            {message}
                        </Alert>
                    </Snackbar>
                </React.Fragment>
            )
            }
        </Box >
    );
}

export function RoomHorizontalLinearStepper({ getRoomsByUnit, open, setOpen, currentPropertyId, currentUnitId }) {
    const steps = ['Room Details'];
    // Formik form
    const { values, handleChange, resetForm } = useFormik({ initialValues: roomInitialValues })
    // End of formik

    const navigate = useNavigate();
    const [activeStep, setActiveStep] = React.useState(0);
    const [skipped, setSkipped] = React.useState(new Set());
    const [properties, setProperties] = React.useState([]);
    const [roomUnit, setRoomUnit] = React.useState(null);

    const isStepOptional = (step) => {
        return step === 1;
    };

    const isStepSkipped = (step) => {
        return skipped.has(step);
    };

    const nextStep = () => {
        let newSkipped = skipped;
        if (isStepSkipped(activeStep)) {
            newSkipped = new Set(newSkipped.values());
            newSkipped.delete(activeStep);
        }

        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped(newSkipped);
    }

    const handleNext = () => {
        if (activeStep + 1 === 1) {
            addRooms();
        } else {
            nextStep()
        }
    };

    const { POST, GET } = useAPI()
    const [loading, setLoading] = React.useState(false);
    const [done, setDone] = React.useState(false);
    const [errorText, setErrorText] = React.useState(null);
    const [property, setProperty] = React.useState(null);
    const [units, setUnits] = React.useState([])
    const [propertyId, setPropertyId] = React.useState(string || null);
    const [unitId, setUnitId] = React.useState(string);


    const token = localStorage.getItem('token');

    const getUnitByPropertyId = React.useCallback(async (currentPropertyId) => {

        if (currentPropertyId) {
            const token = localStorage.getItem('token');
            setLoading(true);
            setErrorText(null);
            const response = await axios.get(`${BURL}/admin/properties/${currentPropertyId}/units`, {
                params: {
                    withRooms: false,
                    withProperty: true
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setLoading(false);
            if (response?.status) {
                const res = await response.data.data;

                const roomUnit = await res.find((unit) => unit.id === +currentUnitId);
                setRoomUnit(roomUnit)
                setProperty(res[0].property);
                setUnits(res);
            } else {
                // setErrorText(response.message ?? 'Request Error');
            }
        }
    }, [currentUnitId]);

    React.useEffect(() => {
        if (currentPropertyId) {
            getUnitByPropertyId(currentPropertyId);
        }
    }, [currentPropertyId, currentUnitId, getUnitByPropertyId]);

    const handleSkip = () => {
        if (!isStepOptional(activeStep)) {
            throw new Error("You can't skip a step that isn't optional.");
        }

        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped((prevSkipped) => {
            const newSkipped = new Set(prevSkipped.values());
            newSkipped.add(activeStep);
            return newSkipped;
        });
    };

    const handleReset = () => {
        setActiveStep(0);
        setOpen(false);
        setDone(false);
        window.location.reload();
    };

    // when the dialog close
    React.useEffect(() => {
        if (!open && done) {
            setOpen(false);
            setDone(false);
            setActiveStep(0);
        }
        getRoomsByUnit && getRoomsByUnit();
    }, [open, done])

    React.useEffect(() => {
        // if (propertyId) {
        getUnitByPropertyId();
        // }
    }, [currentPropertyId]);


    const addRooms = async () => {
        setLoading(true);
        setErrorText(null);
        values.propertyId = currentPropertyId;
        values.unitId = currentUnitId;
        const response = await POST(`admin/properties/units/rooms/new`, values);
        setLoading(false);
        if (response) {
            nextStep();
        } else {
            setErrorText(response.message);
        }
    }

    const loader = <SmallLoader />
    return (
        <Box sx={{ width: '100%' }}>
            <Stepper activeStep={activeStep}>
                {steps.map((label, index) => {
                    const stepProps = {};
                    const labelProps = {};
                    if (isStepSkipped(index)) {
                        stepProps.completed = false;
                    }
                    return (
                        <Step key={label} {...stepProps}>
                            <StepLabel {...labelProps}>{label}</StepLabel>
                        </Step>
                    );
                })}
            </Stepper>
            {activeStep === steps.length ? (
                <React.Fragment>
                    <Typography sx={{ mt: 2, mb: 1 }}>
                        <div className="max-w-md p-5 text-center">
                            Room setup has been completed. Click proceed to view rooms or click out to close this dialog.
                        </div>
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                        <Box sx={{ flex: '1 1 auto' }} />
                        <Button onClick={handleReset}>Proceed</Button>
                    </Box>
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <div sx={{ mt: 2, mb: 1 }}>
                        {
                            activeStep === 0 &&
                            <div className="w-[20rem] lg:w-[30rem]">
                                <div className="my-10">
                                    <h1 className='text-3xl font-bold text-black'> Room Details</h1>
                                    <p className="text-[0.8em] mt-2">Enter the room information.</p>
                                    {errorText && <div className='text-sm text-red-500 py-2'>{errorText}</div>}
                                </div>
                                <div className='flex flex-col gap-5'>
                                    <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                        <label htmlFor="" className=''>Property</label>
                                        <input type="text" disabled className='disabled:text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#0000008f]' name='property' defaultValue={property?.name} placeholder="Room BA" />
                                    </div>

                                    <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                        <label htmlFor="" className=''>Unit</label>
                                        <input type="text" disabled className='disabled:text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#0000008f]' name='unit' defaultValue={roomUnit?.name} placeholder="Room Unit" />
                                    </div>

                                    <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                        <label htmlFor="" className=''>Room Tag</label>
                                        <input type="text" className='text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#0000008f]' name='tag' value={values.tag} onChange={handleChange} placeholder="Room BA" />
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                        <Box sx={{ flex: '1 1 auto' }} />
                        {isStepOptional(activeStep) && (
                            <Button color="inherit" onClick={handleSkip} sx={{ mr: 1 }}>
                                Skip
                            </Button>
                        )}

                        <Button onClick={handleNext} disabled={loading} className='flex gap-1 items-center'>
                            {activeStep === steps.length - 1 ? 'Finish' : 'Next'}

                            {loading && loader}
                        </Button>
                    </Box>
                </React.Fragment>
            )
            }
        </Box >
    );
}
